"use client";

import { useInfront } from "@/context/infront-context";
import {
  createInstrumentSlug,
  DEFAULT_CONTENT,
} from "@/services/infront/utils";
import { useRouter } from "next/navigation";
import { useEffect, useRef } from "react";

const ID = "swedish-index-list";

const EXCHANGE_INDICIES = [
  {
    feed: 17921,
    ticker: "OMXS30",
  },
  {
    feed: 17921,
    ticker: "OMXSPI",
  },
  {
    feed: 17921,
    ticker: "OMXSMCPI",
  },
  {
    feed: 17921,
    ticker: "OMXSSCPI",
  },
  {
    feed: 17921,
    ticker: "OMXSLCPI",
  },
];

const SECTOR_INDICIES = [
  {
    feed: 17921,
    ticker: "SX4010PI",
  },
  {
    feed: 17921,
    ticker: "SX3010PI",
  },
  {
    feed: 17921,
    ticker: "SX55PI",
  },
  {
    feed: 17921,
    ticker: "SX5510PI",
  },
  {
    feed: 17921,
    ticker: "SX5520PI",
  },
  {
    feed: 17921,
    ticker: "SX5010PI",
  },
  {
    feed: 17921,
    ticker: "SX4020PI",
  },
  {
    feed: 17921,
    ticker: "SX60PI",
  },
  {
    feed: 17921,
    ticker: "SX3020PI",
  },
  {
    feed: 17921,
    ticker: "SX30PI",
  },
  {
    feed: 17921,
    ticker: "SX4510PI",
  },
  {
    feed: 17921,
    ticker: "SX20PI",
  },
  {
    feed: 17921,
    ticker: "SX5020PI",
  },
  {
    feed: 17921,
    ticker: "SX50PI",
  },
  {
    feed: 17921,
    ticker: "SX4030PI",
  },
  {
    feed: 17921,
    ticker: "SX35PI",
  },
  {
    feed: 17921,
    ticker: "SX4040PI",
  },
  {
    feed: 17921,
    ticker: "SX10PI",
  },
  {
    feed: 17921,
    ticker: "SX15PI",
  },
  {
    feed: 17921,
    ticker: "SX4050PI",
  },
  {
    feed: 17921,
    ticker: "SX65PI",
  },
];

const SwedishIndexList = () => {
  const router = useRouter();
  const { isReady, load } = useInfront();

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(
      () => {
        if (!isReady || !active) return;

        widgetRef.current?.destroy();
        widgetRef.current = null;

        const widgetOptions = new window.Infront.QuoteListWidgetOptions();

        widgetOptions.onInstrumentSelected = (instrument: {
          feed: number;
          ticker: string;
        }) => {
          router.push(
            createInstrumentSlug(instrument.feed, instrument.ticker)
          );
        };

        widgetOptions.instruments = EXCHANGE_INDICIES;
        widgetOptions.widgetTitle = "Index";
        widgetOptions.defaultContent = DEFAULT_CONTENT;
        widgetOptions.maxItems = 50;
        widgetOptions.sortable = true;
        widgetOptions.enableChangeStatusColors = true;
        widgetOptions.instrumentTypes = ["INDEX"];

        widgetOptions.columns = [
          {
            name: "FULL_NAME",
            flag: true,
          },
          "LAST",
          "CHANGE",
          "PCT_CHANGE",
          "ONE_W_PCT_CHANGE",
          "YTD_PCT_CHANGE",
          "ONE_Y_PCT_CHANGE",
          "FIVE_Y_PCT_CHANGE",
          "TIME",
        ];

        const dropdownOptions = new window.Infront.DropDownOptions();

        dropdownOptions.title = "Listor";
        dropdownOptions.list = ["Börsindex Sverige", "Sektor Sverige"];
        dropdownOptions.closeOnClick = true;
        dropdownOptions.sortAlphabetically = false;
        dropdownOptions.preSelectedItems = dropdownOptions.list[0];
        dropdownOptions.onItemClicked = (item: string) => {
          dropdownOptions.preSelectedItems = item;

          switch (item) {
            case "Börsindex Sverige":
              widgetOptions.instruments = EXCHANGE_INDICIES;
              break;
            case "Sektor Sverige":
              widgetOptions.instruments = SECTOR_INDICIES;
              break;
          }

          reInitList();
        };

        widgetOptions.customDropDowns = [dropdownOptions];

        widgetRef.current = window.infront.quoteList(`#${ID}`, widgetOptions);

        const reInitList = () => {
          widgetRef.current?.destroy();
          widgetRef.current = window.infront.quoteList(`#${ID}`, widgetOptions);
        };
      }
    );

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, router]);

  return <div className="card" id={ID} />;
};

export default SwedishIndexList;
